define('modules/audiences/segments/createExport/main',["T1Module"], function (T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "audiences/segments/createExport",
      viewCfgs: {
        createExport: {}
      },
      defaultView: "createExport"
    });
  }
  return instance;
});
